
export default function NotFoundPage() {

    return (
        <>
            <h2 >Page not found
            </h2>
            <p >Be Prepared for what's coming</p>

        </>

    );
}
